import marketdata from "../data/Services/marketdata";

/**
 * Hard reload ignoring cache, preserving authentication: auth data is stashed
 * in localStorage ("force-reload-auth") and restored by the boot path.
 * @param {{ viaBrokerAuth: boolean }} options
 */
export const forceReloadWithoutCache = ({ viaBrokerAuth }) => {
  try {
    const authData = {
      broker: marketdata.broker,
      auth: marketdata.auth,
      loginMethod: viaBrokerAuth ? "brokerAuth" : "credentials",
      timestamp: Date.now(),
    };
    localStorage.setItem("force-reload-auth", JSON.stringify(authData));

    if (viaBrokerAuth) {
      const originalToken = sessionStorage.getItem("original-auth-token");
      if (originalToken) {
        localStorage.setItem("force-reload-original-token", originalToken);
      }
    }
  } catch (error) {
    // Preservation is best-effort — the reload itself must still happen.
    console.error(
      "[forceReload] auth preservation failed — reloading anyway:",
      error,
    );
  }
  window.location.reload(true);
};
